export default function BagIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
    >
      <rect
        width="78.712"
        height="78.712"
        x=".589"
        y=".518"
        fill="#E6F8EC"
        rx="39.356"
      />
      <path
        fill="#00B63E"
        d="M35.728 27.224h8.433l4.13-6.237c.614-.879-.088-2.196-1.143-2.196H32.653c-1.054 0-1.756 1.317-1.142 2.196l4.217 6.237Z"
      />
      <path
        fill="#00B63E"
        fillRule="evenodd"
        d="M44.161 30.035h-8.433c-.176.132-.373.264-.57.395a12.32 12.32 0 0 0-.572.396c-.63.398-1.35.81-2.128 1.254-5.406 3.09-13.597 7.772-13.597 20.444a8.436 8.436 0 0 0 8.434 8.433h25.3a8.435 8.435 0 0 0 8.433-8.433c0-12.598-8.161-17.299-13.528-20.39a54.257 54.257 0 0 1-2.197-1.308c-.439-.264-.878-.527-1.142-.791Zm-12.65 9.839a2.775 2.775 0 0 0 2.811 2.811c1.494 0 2.812-1.23 2.812-2.811 0-1.493-1.318-2.811-2.812-2.811-1.58 0-2.81 1.318-2.81 2.811ZM45.567 53.93c1.493 0 2.811-1.23 2.811-2.812 0-1.493-1.318-2.81-2.811-2.81-1.581 0-2.811 1.317-2.811 2.81a2.775 2.775 0 0 0 2.811 2.812Zm1.493-12.563L35.728 52.612a1.924 1.924 0 0 1-2.899 0c-.878-.79-.878-2.108 0-2.987l11.245-11.157c.79-.878 2.108-.878 2.986 0a2.069 2.069 0 0 1 0 2.9Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
